export default __webpack_public_path__ + "static/icon-menstruacion-act-74a9b9c5f89bfceae44b31a8502d73b3.png";